import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import Sidebar from "./Sidebar";
import HomeCenter from "./HomeCenter";
import HomeCenterChat from "./HomeCenterChat";

export default function Home() {
  const [currentView, setCurrentView] = useState(0);

  return (
    <div>
      <Box sx={{ flexGrow: 1, paddingX: { xs: "20px", sm: "100px" }, paddingY: "60px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} sx={{ marginTop: { xs: "20px", sm: "110px" } }}>
            <Sidebar currentView={currentView} setCurrentView={setCurrentView} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            sx={{
              maxHeight: '98vh',
              overflow: 'auto',
              '::-webkit-scrollbar': { display: 'none' }, // For Chrome, Safari, and Opera
              scrollbarWidth: 'none', // For Firefox
              msOverflowStyle: 'none', // For Internet Explorer and Edge
            }}
          >
            {currentView === 0 ? <HomeCenter /> : <HomeCenterChat />}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
